<template>
    <div class="col-12 p-4 row justify-content-center">
        <h2 class="title col-12">
            {{ t("new-general.video-session") }}
        </h2>

        <div
            class="col-12 card card-outline card-primary p-2"
            :class="{ 'col-md-8': forms == 1 }"
            v-if="!loading && treino.id"
        >
            <form @submit.prevent="submit" class="row flex-wrap col-12">
                <div class="col-12 p-2">
                    <!-- <label>{{t(isProfile ? 'student-profile.name':'exercices.title')}}</label> -->
                    <div
                        class="row p-o m-0 justify-content-between align-items-center"
                    >
                        <InputColor
                            v-model:pure-color="treino.colors.title[0]"
                            style="width: 2rem; height: 2rem"
                        />

                        <input
                            type="text"
                            v-model="treino.title"
                            class="form-control"
                            :placeholder="t('gifs.title')"
                            required
                            style="
                                flex: 1 !important;
                                text-align: center;
                                text-transform: uppercase;
                            "
                            :style="{
                                backgroundColor: treino.colors.title[0],
                                color: treino.colors.title[1],
                            }"
                        />

                        <InputColor
                            v-model:pure-color="treino.colors.title[1]"
                            style="width: 2rem; height: 2rem"
                        />
                    </div>
                </div>
                <div
                    class="row m-0 p-0 col-12 gap-1"
                    v-for="i in forms"
                    :key="i"
                    :class="{ 'col-md-12': forms == 1, 'col-md-6': forms > 1 }"
                >
                    <hr class="hr col-12" v-if="forms > 1" />
                    <h5 class="h5 text-bold col-12" v-if="forms > 1">
                        {{ t("new.ex" + i) }}
                    </h5>
                    <div class="col-12 col-md-7">
                        <!-- duration	charge	series	group	 -->
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_duration' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="t('gifs.duration')"
                                    v-model="fillVar(i)['h_duration']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.duration[0],
                                        color: fillVar(i).colors.duration[1],
                                    }"
                                />
                                <label
                                    :for="'h_duration' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['duration']"
                                class="form-control"
                                required
                                :placeholder="t('gifs.duration')"
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_charge' + i"
                                    :placeholder="
                                        t('new-general.video-session-charge')
                                    "
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_charge']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.charge[0],
                                        color: fillVar(i).colors.charge[1],
                                    }"
                                />
                                <label
                                    :for="'h_charge' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['charge']"
                                class="form-control"
                                required
                                :placeholder="
                                    t('new-general.video-session-charge')
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_series' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="t('new-general.blocks')"
                                    v-model="fillVar(i)['h_series']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.series[0],
                                        color: fillVar(i).colors.series[1],
                                    }"
                                />
                                <label
                                    :for="'h_series' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['series']"
                                class="form-control"
                                required
                                :placeholder="t('new-general.blocks')"
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_group' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t('treinos.exercices.relation')
                                    "
                                    v-model="fillVar(i)['h_group']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.group[0],
                                        color: fillVar(i).colors.group[1],
                                    }"
                                />
                                <label
                                    :for="'h_group' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['group']"
                                class="form-control"
                                required
                                :placeholder="t('treinos.exercices.relation')"
                            />
                        </div>
                    </div>
                    <div
                        class="col-12 col-md-5 position-relative overflow-auto"
                    >
                        <video
                            v-if="selectedVideo"
                            controls
                            muted
                            :src="selectedVideo.url"
                            class="col-12"
                        >
                            Video nao suportado
                        </video>
                        <button
                            class="btn btn-warning position-absolute text-white bottom-0 right-0"
                            type="button"
                            @click="() => openModal(i)"
                        >
                            <i class="fa fa-video"></i>
                        </button>
                    </div>
                    <div class="col-12">
                        <div class="col-12 p-2">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :placeholder="t('treinos.objectives')"
                                    :id="`h_description` + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_description']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.description[0],
                                        color: fillVar(i).colors.description[1],
                                    }"
                                />
                                <label
                                    :for="'h_description' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <textarea
                                class="form-control"
                                rows="5"
                                :name="'objetivos' + i"
                                v-model="fillVar(i)['description']"
                                maxlength="800"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 py-2">
                    <button class="btn btn-primary mx-2" type="submit">
                        {{ t("treinos.update") }}
                    </button>
                    <button
                        class="btn btn-warning mx-2"
                        @click="back"
                        type="button"
                    >
                        <i class="fa fa-arrow-left mr-2"></i>
                        {{ t("general.back") }}
                    </button>
                </div>
            </form>
        </div>

        <modal-component
            @hide="() => (showModal = false)"
            :show="showModal"
            :classList="['col-12']"
            :title="t('new-general.select-video')"
        >
            <div class="row m-0 p-1">
                <template v-for="(video, i) in this.videos" :key="i">
                    <div class="p-2 file-container col-4 col-md-3">
                        <div class="col-12 video-container m-0 p-0">
                            <video
                                :src="video.url"
                                controls
                                muted
                                class="col-12"
                            ></video>
                        </div>
                        <button
                            class="btn btn-block small mutted bg-success p-0 m-0 text-center text-capitalize"
                            @click="() => select(video)"
                        >
                            {{ video.clube }}
                        </button>
                    </div>
                </template>
            </div>
        </modal-component>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { t } from "@/lang";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
// import {  getExImage } from '@/utilities/HelpFunctions.js'
import InputColor from "@/components/InputColor.vue";
import { getExImage } from "@/utilities/HelpFunctions";

export default {
    name: "NewTreinoView",
    data() {
        return {
            showModal: false,
            newImages: [],
            deletedImages: [],
            urls: [],
            videos: [],
            selectedVideo: null,
            treino: {
                title: "",

                duration: "",
                charge: "",
                series: "",
                group: "",
                description: "",
                imc: "",
                magra: "",

                h_duration: t("gifs.duration"),
                h_charge: t("new-general.video-session-charge"),
                h_series: t("new-general.blocks"),
                h_group: t("treinos.exercices.relation"),
                h_description: t("treinos.description"),
                h_imc: t("student-profile.imc"),
                h_magra: t("student-profile.magra"),
                path: null,
                fitnes_id: null,
                id: null,
                images: [],
                usergif: false,
                userGifUrl: null,

                colors: {
                    title: ["#808080", "#333333"],
                    duration: ["#d0d0d0", "#000000"],
                    charge: ["#d0d0d0", "#000000"],
                    series: ["#d0d0d0", "#000000"],
                    group: ["#d0d0d0", "#000000"],
                    imc: ["#d0d0d0", "#000000"],
                    magra: ["#d0d0d0", "#000000"],
                    description: ["#d0d0d0", "#000000"],
                },
            },
            selected: 1,
            isProfile: false,
        };
    },
    components: {
        ModalComponent,
        InputColor,
    },
    async created() {
        document.title = t("gifs.menu");
        this.SET_LOADING(true);
        await Promise.all([this.getExercice(), this.getVideos()]);
        this.SET_LOADING(false);
    },
    computed: {
        ...mapState(["loading"]),
        forms() {
            return 1;
        },
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_LOADING"]),
        t,
        back() {
            this.$router.push("/video-sessions/" + this.treino.fitnes_id);
        },
        fillVar(i) {
            return i == 1 ? this.treino : this.treino.child;
        },
        select(video) {
            this.fillVar(this.selected).path = video.id;
            this.selectedVideo = video;
            this.fillVar(this.selected).usergif = true;
            this.showModal = false;
        },
        async getExercice() {
            const id = this.$route.params.id;
            const response = await this.get({ url: "fitnesex/" + id + "/get" });

            if (response.status == 200) {
                if (!response.data.exercice.fitnes.is_video) {
                    alert("Nao encontrado");
                    this.$router.push("/video-sessions");
                }
                this.treino = response.data.exercice;
                try {
                    const url = await getExImage(
                        "",
                        this.get,
                        `formactionimg/${this.treino.path}?key_time=${Date.now()}`,
                        "video/webm",
                    );
                    this.selectedVideo = { url };
                } catch (e) {
                    console.log(e);
                }
                console.log(this.treino);
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else if (response.status == 404) {
                alert("Nao encontrado");
                this.$router.push("/video-sessions");
            } else {
                alert(response.data.message);
                this.$router.push("/video-sessions");
            }
        },
        async getVideos() {
            const response = await this.get({ url: "formactions?type=video" });
            if (response.status == 200) {
                this.videos = response.data.formacoes;
                // carregar cada video
                await Promise.all(
                    this.videos.map(
                        (video) =>
                            new Promise((resolve) =>
                                getExImage(
                                    "",
                                    this.get,
                                    `formactionimg/${video.id}?key_time=${Date.now()}`,
                                    "video/webm",
                                ).then((res) => {
                                    video.url = res;
                                    resolve();
                                }),
                            ),
                    ),
                );
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else {
                alert(response.data.message);
            }
        },
        openModal(i) {
            this.selected = i;
            this.showModal = true;
        },

        async submit() {
            if (!this.treino.path) {
                alert(t("gifs.select"));
                return null;
            }
            this.SET_LOADING(true);
            const response = await this.post({
                url: "fitnesex/" + this.treino.id,
                data: this.treino,
            });
            console.log(response);
            if (response.status == 200) {
                alert(t("general.updated"));
                await this.getExercice();
            } else {
                alert(response.data.message);
            }
            console.log(response);
            this.SET_LOADING(false);
        },
        profile() {
            this.isProfile = true;
        },
    },
};
</script>

<style lang="scss" scoped></style>
